"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let didWarn = false;
exports.truncate = (length) => (thingToTruncate) => {
    if (["string", "number"].includes(typeof thingToTruncate)) {
        const stringifiedValue = String(thingToTruncate);
        const truncatedValue = String(thingToTruncate).slice(0, length);
        if (stringifiedValue.length === truncatedValue.length) {
            return thingToTruncate;
        }
        else {
            return truncatedValue + "…";
        }
    }
    if (!didWarn && process.env.NODE_ENV !== "development") {
        console.warn("Attempting to truncate something that is not a JS primitive: this will fail for functions, objects and arrays. Please reconsider the item you are truncating:", thingToTruncate);
        didWarn = true;
    }
    return thingToTruncate;
};
//# sourceMappingURL=truncate.js.map